
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/akademi",
      function () {
        return require("private-next-pages/akademi/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/akademi"])
      });
    }
  